import * as cx from 'classnames'
import castArray from 'lodash-es/castArray'
import compact from 'lodash-es/compact'
import get from 'lodash-es/get'
import uniq from 'lodash-es/uniq'
import * as React from 'react'

import { IItemCard } from '../interface'

import * as styles from './lockupFilesIncluded.module.css'

const LockupFilesIncluded = ({ item, viewType }: IItemCard) => {
  const { attributes } = item

  const filesAttribute = attributes.find(attr =>
    attr.name.includes('files-included')
  )

  const findDimensions = (name: string, abbreviation: string) => {
    const attribute = attributes.find(attr => attr.name.includes(name))

    const dimension = get(attribute, 'value')

    return dimension ? dimension + abbreviation : null
  }

  const dimensions = compact([
    findDimensions('pixel-dimensions', 'px'),
    findDimensions('print-dimensions', 'in')
  ])

  const fileTypes = get(filesAttribute, 'value') || []

  const attributeNames = {
    'Photoshop PSD': 'PSD',
    'InDesign INDD': 'INDD',
    'Quark QXP': 'QXP',
    'Vector EPS': 'EPS',
    'JPG Image': 'JPG',
    'AI Illustrator': 'AI',
    'TIFF Image': 'TIFF',
    'Photoshop ABR': 'ABR',
    'Photoshop GRD': 'GRD',
    'Photoshop PAT': 'PAT',
    'Photoshop ASL': 'ASL',
    'Photoshop ATN': 'ATN',
    'Photoshop CSH': 'CSH',
    'Photoshop HDR': 'HDR',
    'Photoshop JSX': 'JSX',
    'ZXP file': 'ZXP'
  }

  const attrs = viewType === 'grid' ? dimensions.concat(fileTypes) : fileTypes

  if (!attrs || !attrs.length) {
    return null
  }

  return (
    <div
      className={cx({
        [styles.listView]: viewType === 'list',
        [styles.gridView]: viewType === 'grid'
      })}
    >
      <span className={styles.label}>Files Types Included:</span>
      <ul className={styles.fileTypes}>
        {uniq(castArray(attrs)).map((fileType, index) => (
          <li className={styles.fileType} key={index}>
            {get(attributeNames, fileType, fileType)}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default LockupFilesIncluded
